'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'icons';
var width = 512;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = 'M512-7l0 187.2c-.1 28.6-28.7 51.8-64 51.8-35.3 0-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7l0-102.9-128 25.6 0 162.5c-.1 28.6-28.7 51.8-64 51.8-35.3 0-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7l0-143.6 12.9-2.6 160-32 19.1-3.8zM473.1 168.1c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9s-1.5-7.5-6.9-11.9zm-160 40c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9s-1.5-7.5-6.9-11.9zM213.3 304l74.7 0 0 208-288 0 0-208 74.7 0 21.3-32 96 0 21.3 32zM256 336l-59.8 0c-5.9-8.9-13.1-19.6-21.3-32l-61.7 0c-8.3 12.4-15.4 23.1-21.3 32l-59.8 0 0 144 224 0 0-144zM144 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM486.6 288l-88 88 112 0-142.6 142.6-22.6-22.6 11.3-11.3 76.7-76.7-112 0c5.4-5.4 49.2-49.2 131.3-131.3L464 265.4 486.6 288zM95.1 46c-6.6-8.8-17-14-28-14-19.4 0-35 15.7-35 35 0 15.6 5.2 28.6 14.2 41.5 9.9 14.1 23.7 28.2 38.6 40.9 15.7 13.5 31.7 24.8 43.2 32.3 11.5-7.5 27.4-18.8 43.2-32.3 14.9-12.8 28.7-26.8 38.6-40.9 9-12.9 14.2-25.9 14.2-41.5 0-19.4-15.7-35-35-35-11 0-21.4 5.2-28 14L128 89.9 95.1 46zM0 67c0-37 30-67 67-67 14.2 0 27.8 4.5 39 12.5 5.5 3.9 10.5 8.8 14.6 14.3l7.3 9.8 7.3-9.8c4.2-5.6 9.1-10.4 14.6-14.3 11.2-8 24.8-12.5 39-12.5 37 0 67 30 67 67 0 68.5-74.3 121.7-128 152.4-53.7-30.7-128-83.9-128-152.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;